// src/contexts/produtos/combos/ConjuntoContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../../services/Api';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';

const ConjuntoContext = createContext();

export const useConjunto = () => useContext(ConjuntoContext);

export const ConjuntoProvider = ({ children }) => {
    const [conjuntos, setConjuntos] = useState([]);
    const [conjuntoSel, setConjuntoSel] = useState(null);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchConjuntos = useCallback(async () => {
        try {
            const result = await fetchData('/Conjunto', { resumido: true });
            setConjuntos(result);
        } catch (error) {
            console.error("Erro ao buscar conjuntos:", error);
            showMessage(`Erro ao buscar conjuntos! ${error?.message || error}`, 'danger');
        }
    }, [showMessage]);

    useEffect(() => {
        fetchConjuntos();
    }, [fetchConjuntos]);

    const fetchConjuntoById = async (conjuntoId) => {
        try {
            const result = await fetchData('/Conjunto/ObterPorId', { conjuntoId });
            setConjuntoSel(result);
            return result;
        } catch (error) {
            console.error(`Erro ao buscar conjunto ${conjuntoId}:`, error);
            showMessage(`Erro ao buscar conjunto! ${error?.message || error}`, 'danger');
            throw error;
        }
    };

    const addConjunto = async (conjunto) => {
        try {
            const result = await postData('/Conjunto', conjunto);
            setConjuntos([...conjuntos, result]);
            showAlert('Conjunto adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar conjunto:", error);
            showMessage('Erro ao adicionar conjunto!\n' + error, 'danger');
        }
    };

    const updateConjunto = async (conjunto) => {
        try {
            const result = await putData('/Conjunto', conjunto);
            setConjuntos((prev) =>
                prev.map((c) => (c.id === result.id ? result : c))
            );
            showAlert('Conjunto alterado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar conjunto:", error);
            showAlert('Erro ao alterar conjunto!', 'danger');
        }
    };

    const deleteConjunto = async (id) => {
        try {
            await deleteData('/Conjunto', { conjuntoId: id });
            setConjuntos(conjuntos.filter(c => c.id !== id));
            showAlert('Conjunto excluído com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir conjunto:", error);
            showAlert('Erro ao excluir conjunto!', 'danger');
        }
    };

    return (
        <ConjuntoContext.Provider value={{
            conjuntos,
            conjuntoSel,
            setConjuntoSel,
            addConjunto,
            updateConjunto,
            deleteConjunto,
            fetchConjuntoById
        }}>
            {children}
        </ConjuntoContext.Provider>
    );
};
